import {Component, ComponentRef, EventEmitter, input, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {TreeNode} from '../../../../services/treeview.service';
import {TreeviewNodeComponent} from '../treeview-node/treeview-node.component';

@Component({
    selector: 'treeview-page', templateUrl: './treeview-page.component.html', styleUrls: ['./treeview-page.component.scss'],
})
export class TreeviewPageComponent implements OnInit, OnDestroy {
    treeNodes = input.required<TreeNode[]>();
    objectSelected = input.required<EventEmitter<string>>();
    treeNodeChildrenLoaded = input.required<EventEmitter<TreeNode[]>>();
    showStatusColorInTree = input.required<boolean>();

    @ViewChild('vc', {read: ViewContainerRef, static: true}) vc;
    private cache: Map<string, ComponentRef<TreeviewNodeComponent>> = new Map<string, ComponentRef<TreeviewNodeComponent>>();

    constructor() {
    }

    show(): void {
        if (this.cache.size > 0) {
            this.cache.forEach(treeNode => {
                this.vc.insert(treeNode.hostView);
            });
        } else {
            this.regen();
        }
    }

    regen(): void {
        this.vc.clear();
        this.treeNodes().forEach(node => {
            const treeViewNode: ComponentRef<TreeviewNodeComponent> = this.vc.createComponent(TreeviewNodeComponent);

            treeViewNode.setInput('objectSelected', this.objectSelected());
            treeViewNode.setInput('treeNode', node);
            treeViewNode.setInput('treeNodeChildrenLoaded', this.treeNodeChildrenLoaded());
            treeViewNode.setInput('showStatusColorInTree', this.showStatusColorInTree());

            this.vc.insert(treeViewNode.hostView);
            this.cache.set(node.objectID!, treeViewNode);
        });
    }

    hide(): void {
        this.vc.detach();
    }

    ngOnDestroy(): void {
        this.cache.forEach(c => c?.destroy());
    }

    ngOnInit(): void {
        this.show();
    }

    removeNodeFromCache(id): void {
        this.cache.get(id)?.destroy();
    }

}
